import { useMutation } from "@tanstack/react-query";
import request from "../../../Api/Api.js"; // Adjust path as necessary
import { useToast } from "../../Ui/use-toast"; // Make sure to adjust the import path as necessary

function getToken() {
  if (localStorage.getItem("user") != null) {
    return JSON.parse(localStorage.getItem("user")).accessToken;
  } else {
    return "";
  }
}

export function useDeleteSavedQuery() {
  const { toast } = useToast();

  return useMutation({
    mutationFn: (queryId) =>
      request.delete(`/savedQueries/${queryId}`, {
        headers: { Authorization: `Bearer ${getToken()}` },
      }),
    onSuccess: () => {
      toast({
        variant: "success",
        title: "Success!",
        description: "Query deleted successfully!",
      });
    },
    onError: (error) => {
      toast({
        title: "Error",
        description: `Failed to delete query: ${
          error?.message || "An error occurred"
        }`,
        variant: "destructive",
      });
    },
  });
}
